/* lv-mua-nhanh.js — 27/10/2026 (anh "Duyệt cả 6 việc", việc 6). Chỉ trang sản phẩm.
   1) Dòng ưu đãi ngay dưới giá (mọi màn hình); 02/11/2026 QD-2026-11-15: "Buy 2 sets: FREE US shipping" + "3+ sets: extra $5 off".
   2) Điện thoại (≤ 749 px): thanh mua dính đáy kèm giá khi nút mua chính ra khỏi màn hình.
      Chưa chọn size → nút "Choose your size" cuộn tới ô size (không tự chọn size); đã chọn → bấm hộ nút Add to cart chính.
   Bọc try/catch: lỗi thì bỏ, không làm hỏng trang. Không thư viện ngoài. */
(() => {
  'use strict';
  const root = document.querySelector('.m-main-product');
  const priceBlock = root && root.querySelector('.main-product__block-price');
  const atc = root && root.querySelector('product-form.m-product-form--main button[name="add"]');
  if (!root || !priceBlock || !atc) return;
  const NL = String.fromCharCode(10);

  try {
    if (!root.querySelector('.lv-mn-offer')) {
      const p = document.createElement('p');
      p.className = 'lv-mn-offer';
      p.innerHTML = '<strong>Buy 2 sets: FREE US shipping</strong> <span>3+ sets: extra $5 off &middot; applied at checkout</span>';
      priceBlock.appendChild(p);
    }
  } catch (e) { /* bỏ qua */ }

  if (!window.matchMedia('(max-width: 749px)').matches) return;
  try {
    const title = (root.querySelector('.m-product-title') || root.querySelector('.main-product__block-title') || {}).textContent || document.title;
    const bar = document.createElement('div');
    bar.className = 'lv-mn-bar';
    bar.hidden = true;
    bar.innerHTML = '<div class="lv-mn-bar__info"><span class="lv-mn-bar__name"></span><span class="lv-mn-bar__price"></span></div><button type="button" class="lv-mn-bar__btn"></button>';
    bar.querySelector('.lv-mn-bar__name').textContent = title.split(NL).join(' ').replace(/ +/g, ' ').trim();
    document.body.appendChild(bar);
    const btn = bar.querySelector('.lv-mn-bar__btn');
    const priceEl = bar.querySelector('.lv-mn-bar__price');
    const needsSize = () => root.classList.contains('lv-r12-needs-size') || atc.disabled;
    const sizeBox = () => {
      const i = root.querySelector('variant-picker input[name^="Size"]');
      return (i && (i.closest('.m-product-option') || i.parentElement)) || root.querySelector('.main-product__block-variant_picker');
    };
    const paint = () => {
      const pr = priceBlock.querySelector('.m-price-item--last') || priceBlock.querySelector('.m-price');
      priceEl.textContent = pr ? pr.textContent.split(NL).join(' ').replace(/ +/g, ' ').trim() : '';
      btn.textContent = needsSize() ? 'Choose your size' : 'Add to cart';
    };
    let atcVisible = true, pastPrice = false;
    const show = () => {
      const on = !atcVisible && pastPrice;
      if (bar.hidden === !on) return;
      bar.hidden = !on;
      document.body.classList.toggle('lv-mn-on', on);
      if (on) paint();
    };
    new IntersectionObserver(es => { atcVisible = es[0].isIntersecting; show(); }).observe(atc);
    new IntersectionObserver(es => { pastPrice = es[0].boundingClientRect.top < 0; show(); }).observe(priceBlock);
    new MutationObserver(() => { if (!bar.hidden) paint(); }).observe(root, { attributes: true, attributeFilter: ['class'], subtree: false });
    root.addEventListener('change', () => setTimeout(paint, 80), true);
    btn.addEventListener('click', () => {
      if (needsSize()) {
        const s = sizeBox();
        if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        atc.click();
      }
    });
  } catch (e) { /* bỏ qua */ }
})();